import { toast } from "sonner";
import { api, errMsg } from "./api";

// Authenticated download (or open in a new tab) of an admin export.
export async function download(url, filename, openInTab = false) {
  try {
    const r = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(r.data);
    if (openInTab) { window.open(href, "_blank", "noopener"); return; }
    const a = document.createElement("a"); a.href = href; a.download = filename; a.click(); URL.revokeObjectURL(href);
  } catch (e) { toast.error(errMsg(e)); }
}
